var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container index"},[_c('Header',{attrs:{"active":0}}),_c('swiperBox'),_c('Example'),_c('PriceDetail'),_c('Software'),_c('Advantage'),_c('Partner',{attrs:{"title":'合作伙伴'}}),_c('Footer'),_c('Position')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }